import { render, staticRenderFns } from "./rds-total-stats.vue?vue&type=template&id=3d6708a0&scoped=true&"
import script from "./rds-total-stats.vue?vue&type=script&lang=js&"
export * from "./rds-total-stats.vue?vue&type=script&lang=js&"
import style0 from "./rds-total-stats.vue?vue&type=style&index=0&id=3d6708a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6708a0",
  null
  
)

export default component.exports